<style scoped>
.button-wrapper {
  position: relative;
  width: 150px;
  text-align: center;
  margin: 20% auto;
}

.button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #00bfff;
  cursor: pointer;
  color: #fff;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 12px;
}

#upload {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 50px;
  top: 48%;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
</style>
<template>
  <CCard>
    <CCardHeader class="h5 font-weight-bold">Profile</CCardHeader>
    <CCardBody class="p-5">
      <div>
        <form v-on:submit.prevent="postData" class="row">
          <div class="col-md-8 order-2 order-sm-2 order-md-1 order-lg-1 order-xl-1">
            <div class="form-group row">
              <label for="name" class="col-sm-3 col-form-label">Nama</label>
              <div class="col-sm-8">
                <input type="text" class="form-control" id="name" v-model="formData.name" />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">Divisi</label>
              <div class="col-sm-8">
                <input
                  type="text"
                  class="form-control"
                  id="divisi"
                  readonly
                  v-model="formData.divisi"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="username" class="col-sm-3 col-form-label">Username</label>
              <div class="col-sm-8">
                <input type="text" class="form-control" id="username" v-model="formData.username" />
              </div>
            </div>
            <div class="form-group row">
              <label for="pass" class="col-sm-3 col-form-label">Password</label>
              <div class="col-sm-8">
                <input type="password" class="form-control" id="pass" v-model="formData.password" />
              </div>
            </div>
            <div class="form-group text-right mr-5 mt-5">
              <button
                @click="postData"
                type="submit"
                class="btn btn-md btn-success mr-2 px-3"
              >Simpan</button>
            </div>
          </div>
          <div class="col-md-4 order-1 order-sm-1 order-md-2 order-lg-2 order-xl-2 text-center">
            <div class="text-center">
              <img
                src="/img/avatars/9.png"
                style="width:120px"
                class="card-img-top img-circle elevation-2 rounded-circle"
                alt="avatar"
              />
            </div>
            <div class="button-wrapper">
              <span class="label">Upload File</span>

              <input
                type="file"
                name="upload"
                id="upload"
                class="upload-box"
                placeholder="Upload File"
              />
            </div>
          </div>
        </form>
      </div>
    </CCardBody>
  </CCard>
</template>
<script>
import ProfileService from "../../services/profile/profile.service";

export default {
  name: "Profile",
  data() {
    return {
      items: [],
      actionPost: "",
      formData: {
        name: "",
        username: "",
        email: "",
        password: "",
        noTelphone: "",
        foto: "",
        idProfile: ""
      }
    };
  },

  mounted() {
    this.getData();
  },

  methods: {
    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "errorr",
        showCancelButton: true
      });
    },
    alertSuccess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },

    getData() {
      ProfileService.getProfile()
        .then(response => {
          // comment console console.log(response.data.data.content);
          this.items = response.data.data.content;
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    updateData(item, index) {
      this.myModal = true;
      this.formData = item;
      this.actionPost = "update";
    },

    postData() {
      if (this.actionPost == "insert") {
        this.insertData(this.formData);
      } else if (this.actionPost == "update") {
        this.putData();
      }
    },

    insertData(formData) {
      // comment console console.log(formData);
      // comment console console.log("posat");
      ProfileService.postProfile(formData)
        .then(response => {
          this.myModal = false;
          this.alertSuccess();
          this.getData("1");
        })
        .catch(error => {
          // comment console console.log(error);
          this.alertError();
        });
    },

    putData() {
      // comment console console.log("put");
      // comment console console.log(this.formData);

      ProfileService.putProfile(this.formData)
        .then(response => {
          this.myModal = false;

          this.alertSuccess();

          this.getData("1");
        })
        .catch(error => {
          // comment console console.log(error);

          this.alertError();
        });
    }
  }
};
</script>